import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackToggledAnonymousAccountRequirementOff } from "@air/analytics/src/events/useTrackToggledAnonymousAccountRequirementOff";
import { useTrackToggledAnonymousAccountRequirementOn } from "@air/analytics/src/events/useTrackToggledAnonymousAccountRequirementOn";
import { memo, useCallback } from "react";
import { UpsellFlashIconButton } from "~/components/SharePrivateClipModalV2/UpsellFlashIconButton";
import { PermissionToggleInfo } from "~/components/SharePrivateContentModal/shared/PermissionToggleInfo";
import { SharePrivateContentPermissionToggle } from "~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle";
import { SHARE_MODAL_UPSELL_MESSAGE } from "~/constants/upsells";
import { useShareSettings } from "~/hooks/useShareSettings";
export const ShareRequireAccountSetting = /*#__PURE__*/ memo((param)=>{
    let { shortIdInfo, isLoading, onShortUrlUpdate } = param;
    const { requireAccountEnabled } = useShareSettings();
    const { trackToggledAnonymousAccountRequirementOn } = useTrackToggledAnonymousAccountRequirementOn();
    const { trackToggledAnonymousAccountRequirementOff } = useTrackToggledAnonymousAccountRequirementOff();
    const onCheckedChange = useCallback(async (checked)=>{
        const response = await onShortUrlUpdate({
            requireAccount: checked
        });
        if (checked) {
            trackToggledAnonymousAccountRequirementOn({
                share_url: response.id,
                object_id: response.objectId,
                object_type: response.objectType
            });
        } else {
            trackToggledAnonymousAccountRequirementOff({
                share_url: response.id,
                object_id: response.objectId,
                object_type: response.objectType
            });
        }
    }, [
        onShortUrlUpdate,
        trackToggledAnonymousAccountRequirementOff,
        trackToggledAnonymousAccountRequirementOn
    ]);
    return /*#__PURE__*/ _jsx(SharePrivateContentPermissionToggle, {
        label: "Require name and email to view",
        id: "requireAccount",
        isLoading: isLoading,
        checked: !!shortIdInfo.requireAccount,
        disabled: !requireAccountEnabled,
        onCheckedChange: onCheckedChange,
        children: !requireAccountEnabled ? /*#__PURE__*/ _jsx(UpsellFlashIconButton, {
            children: SHARE_MODAL_UPSELL_MESSAGE
        }) : /*#__PURE__*/ _jsx(PermissionToggleInfo, {
            text: "Link visitors must enter name and email to view"
        })
    });
});
ShareRequireAccountSetting.displayName = "ShareRequireAccountSetting";
